module.exports = __webpack_public_path__ + "static/wortmarke-d818c844da9a1317e6415f18dd3879fc.svg";